import { Wrapper } from '@googlemaps/react-wrapper'

const GoogleMapWrapper = ({
  useDynamicJSAPI,
  children,
}: {
  useDynamicJSAPI: boolean
  children: JSX.Element
}) => {
  if (useDynamicJSAPI) {
    return (
      <Wrapper apiKey={process.env.REACT_APP_MAPS_KEY || ''}>
        {children}
      </Wrapper>
    )
  }

  return children
}

export default GoogleMapWrapper
